var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":_vm.invert
      ? _vm.vertical
        ? 'fade-tab-vertical-invert'
        : 'fade-tab-invert'
      : _vm.vertical
      ? 'fade-tab-vertical'
      : 'fade-tab',"id":("tabpanel-" + (_vm.$parent.uid) + "-" + _vm.id),"role":"tabpanel","aria-labelledby":("tab-" + (_vm.$parent.uid) + "-" + _vm.id),"aria-hidden":!_vm.active}},[(_vm.active)?_c('div',{staticClass:"con-tab vs-tabs--content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }